export const LEXICON_SAMPLE_CSV = `original,replacement,isRegex
"Dr.","Doctor",ignore_case
"API","A.P.I.",ignore_case
"cat|dog","pet",regex
`;
